<button class="btn btn--more" modal-close-btn tabindex="0" title="Sluit">
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs">
        <use href="assets/icons-ui.svg#cross-closed"></use>
    </svg>
</button>

<h2 modal-title>Vervangen of toevoegen</h2>

<div class="modal-body" modal-content>
    <p>
        Wilt u een extra {{ vehicleType }} bij ons verzekeren of gaat u binnen 3 maanden één van onderstaande kentekens
        vervangen (ook als u de precieze datum nog niet weer)? Klik uw keuze aan en maak een vrijblijvende
        premieberekening
    </p>
    <ng-container *ngIf="products">
        <form (ngSubmit)="onSubmit()" [formGroup]="form">
            <div class="column-input">
                <input formControlName="new_vehicle" id="vehicle-to-replace" class="radio" value="replace" />
                <label for="vehicle-to-replace">Vervang mijn:</label>
            </div>

            <div *ngIf="products" class="group-toggle">
                <list-flat>
                    <list-flat-item
                        *ngFor="let product of products.purchased_product_replacement"
                        [class.active]="product.purchased_product_sequence_number === replacementChoice.value"
                    >
                        <input
                            (click)="selectOption(product.purchased_product_sequence_number)"
                            [id]="product.purchased_product_sequence_number"
                            [value]="product.purchased_product_sequence_number"
                            formControlName="replacement_choice"
                            type="radio"
                            class="radio"
                        />
                        <label [for]="product.purchased_product_sequence_number">
                            {{ product.description }} ({{ product.license_plate | kenteken }})
                        </label>
                    </list-flat-item>
                </list-flat>
            </div>
            <div class="column-input">
                <input formControlName="new_vehicle" id="extra-vehicle" type="radio" class="radio" value="extra" />
                <label for="extra-vehicle">Of een extra {{ vehicleType }} toevoegen</label>
            </div>
            <div class="btn-group btn-group--spread">
                <button class="btn btn--link" modal-close>Annuleren</button>
                <button [disabled]="!form.valid" class="btn btn--primary" type="submit">Ga verder</button>
            </div>
        </form>
    </ng-container>
</div>
